import { ContentsInProgress } from './ContentsInProgress';
import { MainContents } from './MainContents';
import { MyContents } from './MyContents';
import { PaginatedContents } from './PaginatedContents';

export const Sections = {
  MyContents,
  ContentsInProgress,
  MainContents,
  PaginatedContents,
};
